module.exports = __webpack_public_path__ + "static/media/nav-claims-hover.1bd7abeb.svg";